import { render, staticRenderFns } from "./BaseProductReview.vue.html?vue&type=template&id=1729ea02&scoped=true&"
import script from "./BaseProductReview.component.js?vue&type=script&lang=vueJs&"
export * from "./BaseProductReview.component.js?vue&type=script&lang=vueJs&"
import style0 from "./BaseProductReview.scoped.scss?vue&type=style&index=0&id=1729ea02&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1729ea02",
  null
  
)

export default component.exports